import { Card, Row, Space } from "@masterteam/mt-design-react";
import React from "react";
import { useIntl } from "react-intl";

import useIsAr from "../../../Hooks/useIsAr";

import "./style.scss";

const ReportTypes = ({ selectedReport, setSelectedReport, items }) => {
  const intl = useIntl();

  return (
    <Card className="reports-types-container">
      <Row align="center" className="header-item">
        <Space>
          <h3>{intl.formatMessage({ id: "common.reports" })}</h3>
        </Space>
      </Row>

      {items?.map((item) => (
        <Row
          key={item?.Type}
          align="center"
          justify="between"
          className={`type-item ${
            item?.Type === selectedReport.Type && "active"
          }`}
          onClick={() => {
            setSelectedReport(item);
          }}
        >
          <Space>
            <h3>{item?.Name}</h3>
          </Space>
        </Row>
      ))}
    </Card>
  );
};

export default ReportTypes;
